const DashedCircleLoader = () => {
    return (
        <div className='lds-roller'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>

    );
  };

  export default DashedCircleLoader;
